import { MealType } from '../../common/commonTypes';

export const checkMeals = (meals: MealType[]): MealType[] => {
    return meals.filter((meal) => {
        return Object.values(meal).every((value) => value !== null && value !== undefined);
    });
};

export const makeMealsForSaving = (confirmedMeals: MealType[], userId: string) => {
    // we are using this mapping instead of simple destructuring to filter out possible extra fields
    return confirmedMeals.map((meal) => {
        return {
            name: meal.name,
            weight: meal.weight,
            calories: meal.calories,
            protein: meal.protein,
            fats: meal.fats,
            carbsNoSugars: meal.carbsNoSugars,
            sugars: meal.sugars,
            userId,
        };
    });
};
